const mutations = {
	setMainMenu(state, { menu }) {
		state.mainMenu = menu;
	},

	setFooterLinks(state, { privacyLink, imprintLink }) {
		state.footerLinks = {
			privacyLink,
			imprintLink,
		};
	},

	setTheme(state, { primaryColor, secondaryColor, logoUrl }) {
		state.theme = {
			...state.theme,
			primaryColor,
			secondaryColor,
			logoUrl,
		};
	},
};

export { mutations as default };
